import { useState, useEffect, useCallback } from "react";
import { Coffee, LogOut } from "lucide-react"; // eslint-disable-line no-unused-vars
import { api } from "@/lib/api";
import { PinScreen } from "@/components/admin/PinScreen";
import { QuotesBoard } from "@/components/admin/QuotesBoard";
import { CatalogManager } from "@/components/admin/CatalogManager";
import { ExtrasPanels } from "@/components/admin/ExtrasPanels";

const TABS = [
  { id: "preventivi", label: "Preventivi" },
  { id: "listino", label: "Listino" },
  { id: "calendario", label: "Date" },
  { id: "statistiche", label: "Statistiche" },
  { id: "sicurezza", label: "Sicurezza" },
];

export default function Admin() {
  const [authed, setAuthed] = useState(null);
  const [tab, setTab] = useState("preventivi");

  const checkAuth = useCallback(async () => {
    const token = sessionStorage.getItem("bliss_admin_token");
    if (!token) return setAuthed(false);
    try {
      await api.get("/auth/verify");
      setAuthed(true);
    } catch {
      sessionStorage.removeItem("bliss_admin_token");
      setAuthed(false);
    }
  }, []);

  useEffect(() => { checkAuth(); }, [checkAuth]);

  const logout = () => {
    sessionStorage.removeItem("bliss_admin_token");
    setAuthed(false);
  };

  if (authed === null) return <div className="min-h-screen flex items-center justify-center text-sm text-[#8a7a6d]">Caricamento…</div>;
  if (!authed) return <PinScreen onSuccess={() => setAuthed(true)} />;

  return (
    <div className="min-h-screen bg-[#0F172A] text-slate-100">
      <header className="bg-[#1E293B] border-b border-slate-700 px-4 py-3 sticky top-0 z-30">
        <div className="max-w-6xl mx-auto flex items-center justify-between gap-3">
          <div className="flex items-center gap-3">
            <img src="/logo.png" alt="Bliss Café" className="h-9 w-auto" />
            <span className="font-display font-bold text-lg text-slate-300">Gestionale</span>
          </div>
          <button data-testid="admin-logout-button" onClick={logout} className="flex items-center gap-1.5 text-xs text-slate-400 hover:text-white">
            <LogOut className="w-4 h-4" /> Esci
          </button>
        </div>
        <nav className="max-w-6xl mx-auto flex gap-1 mt-3 overflow-x-auto">
          {TABS.map((t) => (
            <button key={t.id} data-testid={`admin-tab-${t.id}`} onClick={() => setTab(t.id)}
              className={`px-4 py-1.5 rounded-full text-sm font-medium whitespace-nowrap transition-colors ${tab === t.id ? "bg-[#C85A32] text-white" : "text-slate-400 hover:text-white"}`}>
              {t.label}
            </button>
          ))}
        </nav>
      </header>
      <main className="max-w-6xl mx-auto px-4 py-6">
        {tab === "preventivi" && <QuotesBoard />}
        {tab === "listino" && <CatalogManager />}
        {(tab === "calendario" || tab === "statistiche" || tab === "sicurezza") && <ExtrasPanels tab={tab} />}
      </main>
    </div>
  );
}
